"use client";

import { useEffect, useState } from 'react';
import socketService from '@/services/socketService';

function getTokenFromCookie() {
  if (typeof document === 'undefined') return null;
  const match = document.cookie.match(/(?:^|;\s*)token=([^;]+)/);
  return match ? decodeURIComponent(match[1]) : null;
}

export default function SocketProvider({ children }) {
  const [token, setToken] = useState(null);

  useEffect(() => {
    const checkToken = () => {
      const currentToken = getTokenFromCookie();
      if (currentToken !== token) {
        setToken(currentToken);
      }
    };

    checkToken();
    const interval = setInterval(checkToken, 500);
    return () => clearInterval(interval);
  }, [token]);

  useEffect(() => {
    if (token && !socketService.isConnected()) {
      socketService.connect(token);
    } else if (!token && socketService.isConnected()) {
      socketService.disconnect();
    }
  }, [token]);

  return <>{children}</>;
}
